import { useMemo, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';

import { IconDelete } from 'src/assets/icons/Delete';
import { EditIcon } from 'src/assets/icons/EditIcon';
import { IconMoreVertical } from 'src/assets/icons/IconMoreVertical';
import { IconSidebar } from 'src/assets/icons/IconSidebar';
import { ChevronIcon } from 'src/components/ChevronIcon';
import { PROJECT_FOLDER_ACTIONS } from 'src/data/project';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles';

export const ProjectFolderActionsDropdown = ({
  className,
  projectFolder,
  chevron,
  onProjectFolderAction,
}) => {
  const styles = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleAction = (e, action) => {
    setAnchorEl(null);
    action.onClick(e, projectFolder);
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const localActions = useMemo(
    () => [
      {
        label: 'Rename',
        onClick: (event, projectFolder) =>
          onProjectFolderAction(PROJECT_FOLDER_ACTIONS.rename, projectFolder),
        icon: <EditIcon />,
      },
      {
        label: projectFolder?.onSidebar ? 'Remove from sidebar' : 'Add to sidebar',
        onClick: (event, projectFolder) =>
          onProjectFolderAction(PROJECT_FOLDER_ACTIONS.toggleSidebarPresence, projectFolder),
        icon: <IconSidebar />,
      },
      {
        label: 'Delete',
        onClick: (event, projectFolder) =>
          onProjectFolderAction(PROJECT_FOLDER_ACTIONS.delete, projectFolder),
        icon: <IconDelete />,
      },
    ],
    [onProjectFolderAction, projectFolder]
  );

  return (
    <>
      <IconButton
        onClick={handleClick}
        className={className}
      >
        {chevron ? (
          <ChevronIcon
            className={styles.icon}
            direction={ROTATE_DIRECTION.down}
          />
        ) : (
          <IconMoreVertical className={styles.icon} />
        )}
      </IconButton>
      <Menu
        classes={{ paper: styles.paper }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleModalClick}
      >
        {localActions.map((action) => (
          <MenuItem
            key={action.label}
            onClick={(e) => {
              handleAction(e, action);
            }}
            className={styles.item}
            disabled={action.disabled}
          >
            {action.icon}
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

ProjectFolderActionsDropdown.propTypes = {
  className: PropTypes.string,
  onProjectFolderAction: PropTypes.func.isRequired,
  projectFolder: PropTypes.object,
  chevron: PropTypes.bool,
};

ProjectFolderActionsDropdown.defaultProps = {
  className: '',
  projectFolder: null,
  chevron: false,
};
